import { Check } from './Icons';
import { cx } from './cx';

export type StepState = 'done' | 'current' | 'pending';

export interface Step {
  label: string;
  state: StepState;
}

export interface StepperProps {
  steps: Step[];
  className?: string;
}

export const Stepper = ({ steps, className = '' }: StepperProps) => (
  <ol className={cx('flex items-center gap-3', className)}>
    {steps.map((step, i) => (
      <li
        key={`${step.label}-${i}`}
        className={cx('flex items-center gap-2', step.state === 'pending' && 'opacity-[.55]')}
        aria-current={step.state === 'current' ? 'step' : undefined}
      >
        <span
          className={cx(
            'flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-caption',
            step.state === 'done' && 'bg-teal-600 text-white',
            step.state === 'current' && 'bg-white text-teal-600 ring-2 ring-apricot-500',
            step.state === 'pending' && 'border border-sage-300 bg-white text-ink-muted',
          )}
        >
          {step.state === 'done' ? <Check width={16} height={16} strokeWidth={3} /> : i + 1}
        </span>
        <span className={cx('text-label', step.state === 'current' && 'font-semibold')}>{step.label}</span>
      </li>
    ))}
  </ol>
);
